import { createFeatureSelector, createSelector } from '@ngrx/store';

import { SupportAccessState } from './support-access.reducer';

export const selectSupportAccessState = createFeatureSelector<SupportAccessState>('supportAccessState');

export const selectSupportAccessDocuments = createSelector(
  selectSupportAccessState,
  ({ entities }: SupportAccessState) => Object.values(entities ?? {}),
);

export const selectIsLoading = createSelector(
  selectSupportAccessState,
  ({ isLoading }: SupportAccessState) => isLoading,
);

export const selectIsCreating = createSelector(
  selectSupportAccessState,
  ({ isCreating }: SupportAccessState) => isCreating,
);

export const selectIsUpdating = createSelector(
  selectSupportAccessState,
  ({ isUpdating }: SupportAccessState) => isUpdating,
);
